import { useUserAgent } from '@/providers/UserAgentProvider';
import { isCompatibleAndroidVersion } from '@/utils/android-utils';
import { FeatureConfigKeys } from '@/utils/athena-feature-config';
import { isAndroidChewyMobileApp } from '@/utils/nma';

import { useFeatureValue } from './useFeatureValue';

/**
 * Generic hook to check if customer's device supports native experience based on a specific feature flag.
 * Supporting the native experience means that the device and app version meets the minimum version required.
 *
 * @param featureKey - The feature flag key to check for minimum version
 * @returns boolean indicating if device supports native experience
 */
export const useDeviceSupportsNativeExperience = (featureKey: FeatureConfigKeys): boolean => {
  const { userAgent } = useUserAgent();
  const minimumVersion = useFeatureValue(featureKey, '');

  if (!userAgent) return false;

  // If the device is not an Android Chewy mobile app, we consider it supports native experience.
  if (!isAndroidChewyMobileApp(userAgent)) return true;

  // However if it is an Android Chewy mobile app, we need to check if the app version meets the minimum version required.
  if (!minimumVersion) return false;

  // If the app version meets the minimum version required, we consider it supports native experience.
  return isCompatibleAndroidVersion(userAgent, minimumVersion.toString());
};
